import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useDebounce } from 'react-use';
import { Controlled as CodeMirror } from 'react-codemirror2';
import {
  Button,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import {useLocalStorage} from 'react-use';
import useNotif from 'hooks/use-notify-hook';
import QuestionContext from '../Utils/context';
import { ACTIONS } from '../Utils/action';

import 'codemirror/lib/codemirror.css';
require('codemirror/mode/javascript/javascript');
require('codemirror/mode/sql/sql');

export default function InputFormula({ scores, QUESTION_ID, FORMULA, SQL_TEXT }) {

  const formulaTemplate = `(() => {
    /*
      id - score - status
      ${scores.map(score => {
        return `> ${score.INDEX_ID} - ${score.SCORE_STATUS == 1 ? `Passed` : score.SCORE_STATUS == 0 ? `Failed` :`Not Applicable`}\n\t`
      })}
    */

    // don't remove this line
    const input = window.formula[${QUESTION_ID}];

    // only update from line below

    // your code...


  })();
  `;

  const [auth] = useLocalStorage('authenticated');
  const context = useContext(QuestionContext);
  const [notif, dispatchNotif] = useNotif();
  const [formula, setFormula] = useState(FORMULA || formulaTemplate);
  const [sql, setSql] = useState(SQL_TEXT || '');

  const [sqlResult, setSqlResult] = useState(0);
  const [sqlError, setSqlError] = useState(``);
  const [sampleInput, setSampleInput] = useState(0);
  const [formulaResult, setFormulaResult] = useState(0);

  const [, cancelSql] = useDebounce(async () => {

    if (!QUESTION_ID) return;

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
        { SQL_TEXT: sql },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          }
        }
      );

      context.dispatchQuestions({
        type: ACTIONS.EDIT,
        payload: {
          QUESTION_ID: QUESTION_ID,
          SQL_TEXT: response.data.SQL_TEXT,
        }
      });

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch(error) {

      dispatchNotif({
        place: `br`,
        message: `Opps..., Something wrong`,
        type: `danger`,
      });

    }

  }, 2000, [sql]);

  const [, cancelFormula] = useDebounce(async () => {

    if (!QUESTION_ID) return;

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
        {FORMULA: formula},
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );

      context.dispatchQuestions({
        type: ACTIONS.EDIT,
        payload: {
          QUESTION_ID: QUESTION_ID,
          FORMULA: response.data.FORMULA,
        }
      });

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {

      dispatchNotif({
        place: `br`,
        message: `Opps..., Something wrong`,
        type: `danger`,
      });

    }


  }, 2000, [formula]);

  const getScore = () => {

    const score = scores.find(score => parseInt(score.INDEX_ID) === parseInt(formulaResult));
    if (!score) return `N/A`;

    return `${score.SCORE_INDEX} (${score.SCORE_STATUS == 1 ? `Passed` : score.SCORE_STATUS == 0 ? `Failed` :`Not Applicable`})`;

  }

  const handleExecuteSql = async () => {

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}questions/execute`,
        {SQL_TEXT: sql},
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );

      setSqlError(null);
      setSqlResult(response.data);
      setSampleInput(response.data);

    } catch (error) {
      setSqlResult(`N\\A`);
      setSqlError(error.response.data['error-info'][2]);
    }
  }

  const handleCalculateFormula = () => {

    try {

      setFormulaResult(eval(formula));

    } catch (error) {
      alert(error)
    }
  }


  useEffect(() => {

    window.formula[QUESTION_ID] = sampleInput;
    handleCalculateFormula();

  }, [sampleInput]);


  useEffect(() => {

    cancelSql();
    cancelFormula();

  }, []);

  return (
    <Row>
      {notif}
      <Col md={6}>
        <Form.Group>
          <Form.Label>SQL Command</Form.Label>
          <CodeMirror
            value={sql}
            autoScroll={true}
            options={{
              mode: `sql`,
              lineNumbers: true,
            }}
            onBeforeChange={(editor, data, value) => setSql(value)}
          />
        </Form.Group>
        <Form.Group>
          <Button onClick={handleExecuteSql}>Execute</Button>
          <p>Query Result: {sqlResult}</p>
          {sqlError && <small className="text-danger">{sqlError}</small>}
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label>Javascript Code Formula</Form.Label>
          <CodeMirror
            value={formula}
            options={{
              mode: `javascript`,
              lineNumbers: true,
            }}
            onBeforeChange={(editor, data, value) => setFormula(value)}
          />
        </Form.Group>
        <Form.Row>
          <Col xs="auto">
            <Form.Control
              value={sampleInput}
              onChange={({ target: { value }}) => {
                setSampleInput(value);
              }}
            />
          </Col>
          <Col xs="auto">
            <Button onClick={handleCalculateFormula}>Execute</Button>
          </Col>
          <Col xs="auto">
            <Button variant="secondary" onClick={() => setFormula(formulaTemplate)}>Reset</Button>
          </Col>
        </Form.Row>
        <Form.Group>
          <p>Expected Result: {getScore()}</p>
        </Form.Group>
      </Col>
    </Row>
  )
}